<div class="content-status container">
  <!-- <div class="row py-2 mt-1">
    <div class="col text-center" *ngIf="userServiceBase">
      <h5 class="mb-0 ">
        <span class="font-weight-bold-500" *ngIf="userServiceBase.userName">{{userServiceBase.userName}}</span>
        <span class="font-size-11" *ngIf="userServiceBase.userMobile"> ({{userServiceBase.userMobile}})</span>
      </h5>
    </div>

  </div> -->

  <div class="row py-2 mt-1">
    <div class="col text-center" *ngIf="userServiceBase">
      <h5 class="mb-0 ">
        <span class="font-weight-bold-500" *ngIf="userServiceBase.userName">{{userServiceBase.userName}}</span>
        <span class="font-size-11" *ngIf="userServiceBase.userMobile"> ({{userServiceBase.userMobile}})</span>
      </h5>
    </div>
    <div class="col-2">
      <button style="border-radius: 10px !important;" type="button"
        class="btn btn-sm cart-btn-paylater font-weight-bold-500 box-shadow-none rounded" (click)="overlayOpen()">
        Help
      </button>
    </div>

  </div>
  <div class="row text-center mt-3" *ngIf="userSelectedStore">
    <div class="col-3"></div>
    <div class="col-8 text-center  ">
      <div class="row">
        <div class="col-9 border border-radius-4 background-grey pt-2">
          <h6>
            <div>
              Your Ticket No :
            </div>
            <span class="font-weight-bold-500 h4"
              *ngIf="userSelectedStore.storeCart && userSelectedStore.storeCart.orderId">
              {{userSelectedStore.storeCart.orderId}}
            </span>
          </h6>
        </div>
        <div class="col-3 cursor pl-0 pr-0" (click)="onViewReceiptClick(receipt)">
          <span class="footericon-view-receipt  float-right"></span>
        </div>
      </div>

    </div>
    <div class="col-3"></div>
  </div>
  <div class="row mt-4" *ngIf="statusinput">
    <div class="col text-center">
      <h6 class="text-warning font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'DRAFT'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
      <h6 class="text-success font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'SCHEDULED'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
      <h6 class="text-success font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'INPROGRESS'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
      <h6 class="text-danger font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'REJECT'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
      <h6 class="text-success font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'COMPLETE'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
      <h6 class="text-success font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'READY'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="row no-gutters" *ngIf="userSelectedStore && statusinput.OrderStatus === 'INPROGRESS'">
        <div class="col">
          <label *ngIf="userSelectedStore.serviceDatetime">{{progressStartTime}}</label>
        </div>
        <div class="col text-right">
          <div>
            <label *ngIf="userSelectedStore.serviceEstimatedDatetime">{{progressEndTime}}</label>
          </div>
        </div>
      </div>
      <div class="row pb-1">
        <div class="col">
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
              aria-valuenow="statusWidthNumber" aria-valuemin="0" aria-valuemax="100" [style.width]="statusWidth"></div>
          </div>
        </div>
      </div>
      <div class="row no-gutters mt-2">
        <div class="col" *ngIf="orderStatus !== 'Rejected'">
          <label class="font-weight-bold-500 mb-0">{{statusMessage}}</label>
        </div>
        <div class="col" *ngIf="orderStatus === 'Rejected'">
          <div>
            <label class="font-weight-bold-500 mb-0">Sorry your order is rejected because : {{rejectreason}} (any
              payment made will be refunded as soon)</label>
          </div>
          <label class="font-weight-bold-500 mb-0">You may call olarme customer support for further information:</label>
        </div>
        <div class="col text-right font-weight-bold-500" *ngIf="statusinput.OrderStatus === 'INPROGRESS'">
          <div *ngIf="timeleft">
            <label>Estimated Pickup {{timeleft}}</label>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col text-center" *ngIf="statusinput.OrderStatus === 'INPROGRESS'">
          <button type="button"
            [ngClass]="{'cursor-pointer': !GetStatusDisable, 'cursor-not-allowed': GetStatusDisable}"
            class="btn btn-outline-secondary border-1 box-shadow-none p-2 pl-4 pr-4  cart-btn-paylater font-weight-bold-500 h6 "
            (click)="onStatusClick()" [disabled]="GetStatusDisable">
            Check Status
          </button>
        </div>
      </div>
      <div class="row" *ngIf="statusinput.OrderStatus === 'INPROGRESS'">
        <div class="col text-center">
          <label for="">{{statusCheckMessage}}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4" *ngIf="orderStatus !== 'Rejected'">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <h5 class="h6 mb-1">Please Proceed to: </h5>
          <p class="mb-0 font-weight-bold-500 h6 text-capitalize" *ngIf="userSelectedStore.serviceCompanyName">
            {{userSelectedStore.serviceCompanyName}}</p>
          <p class="mb-0" *ngIf="userSelectedStore.serviceLocationName">{{userSelectedStore.serviceLocationName}}</p>
          <p class="mb-0" *ngIf="userSelectedStore.serviceLocationAddress">{{userSelectedStore.serviceLocationAddress}}
          </p>
          <span>
            <span class="font-weight-bold" *ngIf="userSelectedStore.serviceLocationContact">Phone : </span>
            {{userSelectedStore.serviceLocationContact}}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row form-group mt-4" *ngIf="orderStatus !== 'Rejected' && orderStatus !== 'Completed'">
    <div class="col text-center">
      <div class="btn-group" role="group" aria-label="scan group">
        <!-- <button style="border-radius: 10px !important;" type="button"
          class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none mr-2 rounded pl-4 pr-4"
          (click)="onCallClick()">
          Call
          Restaurant
        </button> -->
        <button style="border-radius: 10px !important;" type="button"
          class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none mr-2 rounded pl-4 pr-4"
          (click)="onHereClick(assistance)">
          I am here
        </button>
      </div>
    </div>
  </div>
  <div class="row form-group mt-4" *ngIf="orderStatus !== 'Rejected' && settings && settings.oosrcs_allow_referral">
    <div class="col text-center">
      <div class="card bg-dark-blue" style="border-radius: 15px !important;">
        <div class="card-body">
          <div class="row mt-2">
            <div class="col">
              <p class="text-justify m-0 text-white" style="font-weight: 900 !important;"
                *ngIf="userSelectedStore.serviceCompanyName">
                Refer
                {{ecomservice.htmlUtil.textTruncate(userSelectedStore.serviceCompanyName,20)}}
                to your
                friends and earn
                <span
                  *ngIf="settings && settings.oosrcs_referral_percentage">{{settings.oosrcs_referral_percentage}}</span>
                % discounts on your next orders for
                every referral
              </p>
            </div>
          </div>
          <div class="row mt-3 pb-2">
            <div class="col text-right">
              <button type="button" style="background-color:#ffac32;"
                class="rounded-pill btn cart-btn-paylater font-weight-bold-500 box-shadow-none rounded btn-sm"
                (click)="openReferModal(referModal)">
                Refer now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br />
  <br />
  <br />
  <br />
</div>

<app-ecom-footer class="footer"></app-ecom-footer>
<ng-template #receipt>
  <div class="modal-header">
    <h6 class="modal-title pull-left">
      <!-- Invoice <span *ngIf="paymentStatus === '0'">(Unpaid)</span> <span *ngIf="paymentStatus === '1'">(Paid)</span> -->
    </h6>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pt-0">
    <div *ngIf="userSelectedStore">
      <div class="row border-bottom">
        <div class="col-2 text-center">
          <img *ngIf="LogoPath" width="50px" height="50px" [src]="LogoPath" alt="Logo">
        </div>
        <div class="col">
          <div class="">
            <span class="font-weight-bold-500 h5 m-2 mt-3">{{userSelectedStore.serviceCompanyName}}</span>
          </div>
          <div>
            Business No - {{CompanyBusinessNumber}}
          </div>
          <div>
            {{userSelectedStore.serviceLocationAddress}}
          </div>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col"><span class="font-weight-bold-500">Tax Invoice :</span> {{invoiceNumber}}</div>
        <div class="col text-right">
          <span class="font-weight-bold-500">Order no :</span>
          {{userSelectedStore.storeCart.orderId}}
        </div>
      </div>
      <div class="row border-bottom pb-2">
        <div class="col"><span class="font-weight-bold-500">Customer :</span> {{userServiceBase.userName}}</div>
        <div class="col text-right"><span class="font-weight-bold-500">Date :</span> {{orderDatetime}}</div>
      </div>
      <div class="row no-gutters py-2">
        <div class="col-7">
          <div>
            <span class="fw-500 font-weight-bold">Item</span>
          </div>
        </div>
        <div class="col-2">
          <span class="fw-500 font-weight-bold">Qty</span>
        </div>
        <div class="col-3 text-right">
          <span class="fw-500 font-weight-bold">Price</span>
        </div>
      </div>
      <div class="pt-3 pb-3  border-top">
        <div class="row no-gutters py-1" *ngFor="let item of userSelectedStore.storeCart.orderItems;let i=index;">
          <div class="col-7">
            <div class="text-truncate font-weight-bold-500 h6 mb-0">
              {{item.itemName}}
            </div>
            <p class="text-muted text-break font-color-light-grey mb-0" style="font-size: 12px;">
              {{item.variantList[0].variantName}}
            </p>
            <p class="text-muted text-break font-color-light-grey mb-0 fa-xs-small-70"
              *ngFor="let modifierset of item.modifierSetList">
              <small>{{modifierset.modifierName}} - </small>
              <span *ngFor="let modifier of modifierset.modifierOptions;let optionindex=index;">
                {{modifier.optionName}} <span *ngIf="optionindex !== modifierset.modifierOptions.length - 1">,</span>
              </span>
            </p>
          </div>
          <div class="col-2">
            <span>{{item.quantity}}</span>
          </div>
          <div class="col-3 text-right">
            <span>{{item.totalPrice.toFixed(2)}}</span>
          </div>
        </div>
      </div>
      <div class="row no-gutters border-top py-2">
        <div class="col text-right">
          <label for="" class="fw-500 mb-0 font-weight-bold-500">Sub Total</label>
        </div>
        <div class="col-3 text-right">
          <label class="mb-0">
            <span>
              <small *ngIf="position === 'BACK'">
                {{currency}}
              </small>
              {{userSelectedStore.storeCart.orderSubTotal.toFixed(2)}}
              <small *ngIf="position === 'FRONT'">
                {{currency}}
              </small>
            </span>
          </label>
        </div>
      </div>

      <div class="row no-gutters border-top py-2">
        <div class="col text-right">
          <label for="" class="fw-500 mb-0 font-weight-bold-500">Order Discount</label>
        </div>
        <div class="col-3 text-right">
          <label class="mb-0">
            <span>
              <small *ngIf="position === 'BACK'">
                {{currency}}
              </small>
              {{userSelectedStore.storeCart.orderDiscountTotal.toFixed(2)}}
              <small *ngIf="position === 'FRONT'">
                {{currency}}
              </small>
            </span>
          </label>
        </div>
      </div>

      <div class="row" *ngIf="discountsApplied">
        <div class="col">
          <div *ngFor="let discount of discountsApplied">
            <div class="row no-gutters border-top py-2" *ngIf="discount.ooocd_type === 'REFERRAL_DISCOUNT'">
              <div class="col text-right">
                <label for="" class="fw-500 mb-0 font-weight-bold-500">
                  {{discount.ooocd_mod_name}}
                  <span *ngIf="discount.ooocd_percentage > 0">
                    ({{discount.ooocd_percentage}}%)
                  </span>
                </label>
              </div>
              <div class="col-3 text-right">
                <label class="mb-0">
                  <span>
                    <small *ngIf="position === 'BACK'">
                      {{currency}}
                    </small>
                    -{{discount.ooocd_amount.toFixed(2)}}
                    <small *ngIf="position === 'FRONT'">
                      {{currency}}
                    </small>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters border-top py-2" *ngFor="let tax of taxList">
        <div class="col text-right">
          <label for="" class="fw-500 mb-0 font-weight-bold-500">{{tax.TaxName}}</label>
        </div>
        <div class="col-3 text-right">
          <label class="mb-0">
            <span>
              <small *ngIf="position === 'BACK'">
                {{currency}}
              </small>
              {{tax.TaxAmount.toFixed(2)}}
              <small *ngIf="position === 'FRONT'">
                {{currency}}
              </small>
            </span>
          </label>
        </div>
      </div>

      <div class="row" *ngIf="discountsApplied">
        <div class="col">
          <div *ngFor="let discount of discountsApplied">
            <div class="row no-gutters border-top py-2" *ngIf="discount.ooocd_type !== 'REFERRAL_DISCOUNT'">
              <div class="col text-right">
                <label for="" class="fw-500 mb-0 font-weight-bold-500">
                  {{discount.ooocd_mod_name}}
                  <span *ngIf="discount.ooocd_percentage > 0">
                    ({{discount.ooocd_percentage}}%)
                  </span>
                </label>
              </div>
              <div class="col-3 text-right">
                <label class="mb-0">
                  <span>
                    <small *ngIf="position === 'BACK'">
                      {{currency}}
                    </small>
                    -{{discount.ooocd_amount.toFixed(2)}}
                    <small *ngIf="position === 'FRONT'">
                      {{currency}}
                    </small>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters border-top py-2">
        <div class="col text-right">
          <label for="" class="fw-500 mb-0 font-weight-bold-500">Total</label>
        </div>
        <div class="col-3 text-right">
          <label for="" class="font-weight-bold mb-0">
            <span>
              <small *ngIf="position === 'BACK'">
                {{currency}}
              </small>
              {{userSelectedStore.storeCart.orderTotal.toFixed(2)}}
              <small *ngIf="position === 'FRONT'">
                {{currency}}
              </small>
            </span>
          </label>
        </div>
      </div>

      <div class="row no-gutters border-top py-2">
        <div class="col text-right">
          <label for="" class="fw-500 mb-0 font-weight-bold-500">Paid by {{paymentMethod}}</label>
        </div>
        <div class="col-3 text-right">
          <label for="" class="font-weight-bold mb-0">
            <span>
              <small *ngIf="position === 'BACK'">
                {{currency}}
              </small>
              {{userSelectedStore.storeCart.orderTotal.toFixed(2)}}
              <small *ngIf="position === 'FRONT'">
                {{currency}}
              </small>
            </span>
          </label>
        </div>
      </div>

      <br />
      <div class="row form-group email-div">
        <div class="col-6 input-group input-group-lg pr-0" [formGroup]="emailForm">
          <input type="email" class="form-control " placeholder="youremail@mail.com" formControlName="email"
            [ngClass]="{'has-error': ((emailForm.get('email').touched || emailForm.get('email').dirty) &&  emailForm.get('email').errors)}" />
        </div>
        <div class="col text-right pr-0 pl-0">
          <button
            class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none btn-block rounded btn-sm button-border-radius"
            (click)="onSendEmailClick()">
            Send
          </button>
        </div>
        <div class="col text-center">
          <button class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none btn-block rounded btn-sm"
            (click)="onDownloadPdfClick()">
            Download
            <!--<i class="far fa-file-pdf fa-lg cursor"></i>-->
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <span [ngClass]="{'text-success': invoiceRequest, 'text-danger': !invoiceRequest}">{{invoiceMsg}}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #assistance>
  <div class="modal-body">
    <div>
      <label class="font-weight-bold-500 h4" for="">Welcome {{userServiceBase.userName}}</label>
    </div>
    <label class="font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'READY'">
      Will call your name soon for
      pickup
    </label>
    <label class="font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus !== 'READY'">
      Still working on your order please wait.
    </label>
  </div>
</ng-template>

<ng-template #sendEmail>
  <div class="modal-body">
    <div class="row form-group">
      <div class="col">
        <label class="font-weight-bold-500 h5" for="">Email Reciept</label>
      </div>
      <div class="col text-right">
        <button class="btn" type="button" (click)="onDownloadPdfClick()">
          <i class="far fa-file-pdf fa-lg"></i>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <input type="email" [(ngModel)]="invoiceEmail" class="form-control" placeholder="youremail@mail.com">
      </div>
      <div class="col-5 text-right">
        <button class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none mr-2 rounded pl-4 pr-4" type="button"
          (click)="onSendEmailClick()">
          Send Email
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span [ngClass]="{'text-success': invoiceRequest, 'text-danger': !invoiceRequest}">{{invoiceMsg}}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #referModal>
  <div class="modal-body" [formGroup]="referForm">
    <div class="row form-group">
      <div class="col">
        <span class="closeicon cursor" (click)="closeReferModal()">
        </span>
      </div>
      <div class="col">
        <button class="btn cart-btn-paylater btn-block font-weight-bold-500 box-shadow-none mr-2 rounded pl-4 pr-4"
          type="button" (click)="onReferClick()">
          Send Referrals
        </button>
      </div>
    </div>
    <div class="row form-group" formArrayName="referralList">
      <div class="col">
        <div class="row form-group" *ngFor="let referralForm of getReferralControlsList(referForm);let i=index"
          [formGroupName]="i">
          <div class="col">
            <div class="row">
              <div class="col">
                <input class="form-control" type="text" placeholder="Name" formControlName="name" />
              </div>
              <div class="col">
                <ngx-intl-tel-input class="" [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
                  [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                  [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="true"
                  [separateDialCode]="separateDialCode" formControlName="phonenumber" id="phone{{i}}"
                  [ngClass]="{'has-error': ((referralForm.get('phonenumber').touched || referralForm.get('phonenumber').dirty) &&  referralForm.get('phonenumber').errors)}">
                </ngx-intl-tel-input>
                <span class="text-danger" *ngIf="referralForm.get('phonenumber').errors">Invalid number</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span
                  [ngClass]="{'text-success': referForm.value.referralList[i].status, 'text-danger': !referForm.value.referralList[i].status}">{{referForm.value.referralList[i].statusMessage}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span class="text-danger">{{referMessage}}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #olarmepromotionpopup>
  <div class="modal-body rounded" style="background-color:#ffac32;">
    <div class="row no-gutters">
      <div class="col">
        <i class="fas fa-times fa-lg cursor close text-white" (click)="onCloseOlarmePromotionClick()"></i>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <div>
          <h3 style="font-family: Arial-Nova;font-style: normal;">Congratulations</h3>
        </div>
        <div>
          <h4 style="font-family: Arial-Nova;">
            you have earned<img class="img" src="assets\images\olarwallet\9.png" height="30px" alt="">
            <span class="text-white h2 m-0">{{olarPoints}}</span>
          </h4>
        </div>
        <h5 style="font-family: Arial-Nova;">
          You may use them in your next purchase
        </h5>
      </div>
    </div>
  </div>
</ng-template>


<div class="overlay" *ngIf="overlayDisplay">
  <app-ecom-contact-us (submitted)="contactUsEventEmitter($event)"></app-ecom-contact-us>
</div>

<ng-template #displayLoyalty>  
  <div class="modal-body modal-styles">
    <div *ngIf="isLoayltyMemberAlready">
      <div class="row">
        <div class="col text-center">
          <div>
            <label for="">Your are loyalty member of</label>
          </div>
        </div>
        <div class="col-1">
          <button style="margin-top: -10px !important;" type="button" class="close close-button text-dark mr-2" data-dismiss="modal" aria-label="Close"
            (click)="closeLoyalty()">
            <span aria-hidden="true" style="font-size: 40px !important;">&times;</span>
          </button>
        </div>
      </div>
      <div class="row form-group">
        <div class="col text-center">
          <span class="text-gray" class="h5 font-weight-bold">{{userSelectedStore.serviceCompanyName}}</span>
        </div>
      </div>
      <div class="row form-group">
        <div class="col text-center">
          <div>
            <span class="text-gray">
              You have just earned <span class="text-gray" class="h5 font-weight-bold">{{loayltyEarnedPoints}} points</span>
            </span>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col text-center">
          <div>
            <span class="text-gray">
              Your balance  <span class="text-gray" class="h5 font-weight-bold">{{loyaltyCurrentBalance}} points</span>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <label class="text-gray" for="">Redeem when you visit the Restaurant
          </label>
        </div>
      </div>
    </div>
    <div [formGroup]="loyaltyJoinForm" *ngIf="!isLoayltyMemberAlready">
      <div class="row">
        <div class="col text-center">
          <span class="text-gray h5" for="">Your have earned</span>
        </div>
        <div class="col-1">
          <button type="button" style="margin-top: -10px !important;" class="close close-button text-dark mr-2" data-dismiss="modal" aria-label="Close"
            (click)="closeLoyalty()">
            <span aria-hidden="true" style="font-size: 40px !important;">&times;</span>
          </button>
        </div>
      </div>
      <div class="row form-group">
        <div class="col text-center">
          <div>
            <span class="text-gray" class="h5 font-weight-bold">{{loayltyEarnedPoints}} Loyalty Points</span>
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      <div class="row form-group">
        <div class="col text-center">
          <p class="text-gray font-size-15">
            Lets make you Loyalty member to redeem
          </p>
          <p class="text-gray font-size-15">
            If already a member points will be added
          </p>
          <p class="text-gray font-size-15">
            Please advise details
          </p>
        </div>
      </div>
      <div class="row form-group" *ngIf="loyaltyPhoneAndName">
        <div class="col">
          <input type="text" placeholder="Enter your name" name="loyaltyName" id="loyaltyName" formControlName="loyaltyName"
            class="input-group form-control"
            [ngClass]="{'has-error': ((loyaltyJoinForm.get('loyaltyName').touched || loyaltyJoinForm.get('loyaltyName').dirty) &&  loyaltyJoinForm.get('loyaltyName').errors)}"
            aria-label="Enter your name" />
        </div>
      </div>
      <div class="row form-group" *ngIf="loyaltyPhoneAndName">
        <div class="col">
          <ngx-intl-tel-input class="" [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
            [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="true"
            [separateDialCode]="separateDialCode" formControlName="loyaltyPhoneNumber" id="loyaltyPhoneNumber"
            [ngClass]="{'has-error': ((loyaltyJoinForm.get('loyaltyPhoneNumber').touched || loyaltyJoinForm.get('loyaltyPhoneNumber').dirty) &&  loyaltyJoinForm.get('loyaltyPhoneNumber').errors)}">
          </ngx-intl-tel-input>
        </div>
      </div>
      <div class="row form-group">
        <div class="col">
          <input type="email" placeholder="Enter your Email(optional)" name="loyaltyEmail" id="loyaltyEmail" formControlName="loyaltyEmail"
            class="input-group form-control"
            [ngClass]="{'has-error': ((loyaltyJoinForm.get('loyaltyEmail').touched || loyaltyJoinForm.get('loyaltyEmail').dirty) &&  loyaltyJoinForm.get('loyaltyEmail').errors)}"
            aria-label="Email (optional)" />
        </div>
      </div>
      <div class="row form-group" *ngIf="redirect">
        <div class="col text-center">
          <div [ngClass]="{'d-block': redirect, 'd-none': !redirect }">
            <label for="" class="text-success">
              Thank you for joining, popup will close in <span id="redirect"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col text-right">
          <button class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none mr-2 rounded pl-4 pr-4"
            type="button" (click)="onAcceptLoyaltyClick()" [attr.disabled] = "active === 1 ? 'disabled' : null">
            Accept
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>